module.exports = "\r\n  <!--<div *ngIf=\"isUserAuthenticated()\">\r\n    <app-nav-menu></app-nav-menu>\r\n  </div>-->\r\n  <app-nav-menu></app-nav-menu>\r\n<br/>\r\n  <div class='container-fluid'>\r\n    <router-outlet></router-outlet>\r\n  </div>\r\n<!--<div class='container-fluid'>\r\n  <div class='row'>\r\n    <div class='col-sm-3'>\r\n      <app-nav-menu></app-nav-menu>\r\n    </div>\r\n    <div class='col-sm-9 body-content'>\r\n      <router-outlet></router-outlet>\r\n    </div>\r\n  </div>\r\n</div>-->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main